import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import AccountService from "@/services/AccountService";

const AccountScoringContext = createContext({
    accountScoringEnabled: false,
    isLoaded: false,
    setAccountScoringEnabled: () => {},
});

export const AccountScoringProvider = ({ children }) => {
    const [accountScoringEnabled, setAccountScoringEnabled] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        AccountService.getProfile()
            .then((profile) => setAccountScoringEnabled(!!profile?.scoringEnabled))
            .catch(() => setAccountScoringEnabled(false))
            .finally(() => setIsLoaded(true));
    }, []);

    const setEnabled = useCallback((value) => setAccountScoringEnabled(!!value), []);
    const value = useMemo(
        () => ({ accountScoringEnabled, isLoaded, setAccountScoringEnabled: setEnabled }),
        [accountScoringEnabled, isLoaded, setEnabled],
    );

    return <AccountScoringContext.Provider value={value}>{children}</AccountScoringContext.Provider>;
};

export const useAccountScoring = () => useContext(AccountScoringContext);

// Account switch AND recruitment switch.
export const useRecruitmentScoring = (recruitmentScoringEnabled) => {
    const { accountScoringEnabled } = useAccountScoring();
    return accountScoringEnabled && !!recruitmentScoringEnabled;
};

export const ScoringActiveContext = createContext(false);
export const useScoringActive = () => useContext(ScoringActiveContext);
